import { Modal } from '@efast_public/fjd-component-library';

interface UploadFilePreviewModalProps {
  readonly payload: string | undefined;
  readonly onClose: () => void;
  readonly isOpen: boolean;
}

export function UploadFilePreviewModal({
  payload,
  onClose,
  isOpen
}: UploadFilePreviewModalProps) {
  return (
    <Modal
      appElement={document.querySelector('.fjd-base-layout') as HTMLElement}
      closeOnBackdropClick={false}
      open={isOpen}
      onClose={onClose}
      windowSize="fullscreen"
      data-testid="attachment-modal"
    >
      <Modal.Content>
        <object
          aria-label="Antrags-PDF"
          data={`data:application/pdf;base64, ${encodeURI(payload ?? '')}`}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      </Modal.Content>
    </Modal>
  );
}

export default UploadFilePreviewModal;
